import { Injectable, EventEmitter, Input, Output} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http } from '@angular/http';

@Injectable()
export class LoadingService {

    loadingEmitter: EventEmitter<any> = new EventEmitter();
    loadingEmitter2: EventEmitter<any> = new EventEmitter();
    _isClose:boolean;

    @Input() set isClose(flag:boolean){
        this._isClose = flag;
        this.loadingEmitter.emit(flag);
    }

    @Input() set loadingMsg(loadingMsg:string){
        this.loadingEmitter2.emit(loadingMsg);
    }
  
    constructor() {
        this.isClose = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/loading.service.ts